function converterCadaLetraDeCadaPalavraParaUpperCase(valor){
    return valor.toLowerCase().replace(/(?:^|\s)\S/g, function(a) {
        return a.toUpperCase();
      });
}

export default {
    converterCadaLetraDeCadaPalavraParaUpperCase
}